import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { getSalesReferenceAccess } from '../api';

type HeaderUtilityDestination = 'sales-reference' | 'settings';

interface HeaderUtilityActionsProps {
  current?: HeaderUtilityDestination;
}

export default function HeaderUtilityActions({ current }: HeaderUtilityActionsProps) {
  const { user } = useAuth();
  const [salesReferenceEnabled, setSalesReferenceEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (user?.role !== 'sales') {
      setSalesReferenceEnabled(false);
      return () => {
        cancelled = true;
      };
    }

    getSalesReferenceAccess().then((result) => {
      if (!cancelled) {
        setSalesReferenceEnabled(Boolean(result.success && result.data?.sales_reference_enabled));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user?.role]);

  const canViewSalesReference = user?.role === 'admin' || (user?.role === 'sales' && salesReferenceEnabled);

  if (user?.role === 'customer') {
    return null;
  }

  return (
    <>
      {current !== 'sales-reference' && canViewSalesReference && (
        <Link to="/sales-reference" className="btn btn-ghost btn-small" style={{ marginRight: '8px' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          </svg>
          Sales Reference
        </Link>
      )}
      {current !== 'settings' && (
        <Link to="/settings" className="btn btn-ghost btn-small" style={{ marginRight: '8px' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          </svg>
          Settings
        </Link>
      )}
    </>
  );
}